// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SplitOrderCartLineNotesModel, SplitOrderCartNotesModel } from "@insite/client-framework/Types/ApiModels";

const splitOrderCartUrl = "api/v1/custom/cart";

export interface UpdateSplitOrderCartNotesAPIParameters extends ApiParameter {
    splitOrderCartNotes: SplitOrderCartNotesModel;
}

export function updateSplitOrderCartNotes(parameter: UpdateSplitOrderCartNotesAPIParameters) {
    const { splitOrderCartNotes } = parameter;
    return patch<SplitOrderCartNotesModel>(
        `${splitOrderCartUrl}/${parameter.splitOrderCartNotes.cartId}/notes`,
        splitOrderCartNotes,
    );
}

export async function updateSplitOrderCartNotesWithResult(
    parameter: UpdateSplitOrderCartNotesAPIParameters,
): Promise<ServiceResult<SplitOrderCartNotesModel>> {
    try {
        const splitOrderCartLineModel = await updateSplitOrderCartNotes(parameter);
        return {
            successful: true,
            result: splitOrderCartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error?.status === 404) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
            };
        }
        throw error;
    }
}

export interface UpdateSplitOrderCartLineNotesAPIParameters extends ApiParameter {
    splitOrderCartLineNotes: SplitOrderCartLineNotesModel;
}

export function updateSplitOrderCartLineNotes(parameter: UpdateSplitOrderCartLineNotesAPIParameters) {
    const { splitOrderCartLineNotes } = parameter;
    const { cartId, cartLineId, id } = splitOrderCartLineNotes;
    return patch<SplitOrderCartLineNotesModel>(
        `${splitOrderCartUrl}/${cartId}/cartlines/${cartLineId}/deliverydate/${id}/notes`,
        splitOrderCartLineNotes,
    );
}

export async function updateSplitOrderCartLineNotesWithResult(
    parameter: UpdateSplitOrderCartLineNotesAPIParameters,
): Promise<ServiceResult<SplitOrderCartLineNotesModel>> {
    try {
        const splitOrderCartLineModel = await updateSplitOrderCartLineNotes(parameter);
        return {
            successful: true,
            result: splitOrderCartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error?.status === 404) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
            };
        }
        throw error;
    }
}
